import { useEffect, useState } from 'react';
import request from '../../utils/request';
import NoDataAvailable from '../common/NoDataAvailable';
import SnackbarAlert from '../common/SnackbarAlert';
import TableSearch from '../common/TableSearch';
import loader from '../common/loader.gif';
import lock from '../common/lock.png';
import { Link } from 'react-router-dom';
import ForwardIcon from '@mui/icons-material/Forward';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import RestartAltIcon from '@mui/icons-material/RestartAlt';


import {
  Avatar,
  Box,
  Button,
  Card,
  Chip,
  Container,
  Divider,
  Grid,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
  useTheme
} from '@mui/material';
import Footer from 'src/components/Footer';
import moment from 'moment';
import { useSearchParams } from 'react-router-dom';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CreateEdit from './CreateEdit';
import ShareIcon from '@mui/icons-material/Share';
import VisibilityIcon from '@mui/icons-material/Visibility';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import UploadPolicyDoc from './UploadPolicyDoc';
import EndorsementUpdateScreenOne from './EndorsementUpdateScreenOne';
import { useDispatch, useSelector } from 'react-redux';
import HistoryIcon from '@mui/icons-material/History';

import {
  selectEndorsmentScreenNumber,
  updateEndorsementFormData,
  updateEndorsementScreenNumber,
  updateSumInsuredSectionData
} from 'src/features/rfqDataSlice';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import EndorsementUpdateScreenTwo from './EndorsementUpdateScreenTwo';
import EndorsementPreview from './EndorsementPreview';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import SendIcon from '@mui/icons-material/Send';
import PremiumRequestPreview from './PremiumRequestPreview';
import UploadEndorsementDoc from './UploadEndorsementDoc';
import EndorsementView from './EndorsementView/EndorsementView';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import QcComparisonDialog from './QcComparisonDialog';
import ShareToInsurer from './ShareToInsurer';
import CancelEndorsementDialog from './CancelEndorsementDialog';
import { checkPermission, checkRFQEditPermission } from 'src/utils/permission';
import NoPermissionContent from '../common/NoPermissionContent';
import TableSearchWithIcon from '../common/TableSearchWithIcon';
import ReshareEndorsementPreview from './ReshareEndorsementPreview';
import EndorsementAttachmentDialog from './AttachmentDialog';
import PolicyDataCompare from './PolicyDataCompare';
import { useFormik } from 'formik';
import AdvancedFilter from './AdvancedFilter';

function EndorsementList() {
  const theme = useTheme();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const policyId = searchParams.get('policyid');
  const [showCreateEdit, setShowCreateEdit] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const [offset, setOffset] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(100);
  const [totalCount, setTotalCount] = useState<number>(0);
  interface SearchState {
    text: string;
    triggerId: number;
  }
  const [search, setSearch] = useState<SearchState>({
    text: '',
    triggerId: Date.now(),
  });
  const [endorsementListData, setEndorsementListData] = useState<any[]>([]);
  const [endoresementEditDatas, setEndoresementEditData] = useState(null);
  const [qCEditStatus, setQCEditStatus] = useState(false);
  const [nonQCEditStatus, setNonQCEditStatus] = useState(false);
  const [endorsementData, setEndorsementData] = useState<any>(null);
  const [openEndorsementDocUploadForm, setOpenEndorsementDocUploadForm] = useState(false);
  const [openEndorsementView, setOpenEndorsementView] = useState(false);
  const [openEndorsementQcBox, setOpenEndorsementQcBox] = useState(false);
  const [openShareToInsurerBox, setOpenShareToInsurerBox] = useState(false);
  const [loaders, setLoader] = useState<boolean>(false);
  const [deleteData, setDeleteData] = useState<any>([]);
  const [deleteopen, setDeleteOpen] = useState(false);
  const [showSnackBarAlert, setShowSnackBarAlert] = useState({
    status: false,
    type: 'success',
    message: null
  });

  const [openAttachmentDialog, setOpenAttachmentDialog] = useState(false);
  const [selectedEndorsement, setSelectedEndorsement] = useState(null);
  const [endorsementQCPermission, setEndorsementQCPermission] = useState<boolean>(false);
  const [endorsementCreatePermission, setEndorsementCreatePermission] = useState<boolean>(false);
  const [endorsementViewPermission, setEndorsementViewPermission] = useState<boolean>(true);
  const [endorsementDeletePermission, setEndorsementDeletePermission] = useState<boolean>(false);
  const [endorsementUpdatePermission, setEndorsementUpdatePermission] = useState<boolean>(false);

  const [openComareScreen, setOpenCompareScreen] = useState(false);
  const [selectPolicyCompare, setSelectPolicyCompare] = useState(null);
  const [policyQCPermission, setpolicyQCPermission] = useState<boolean>(true);
  const [showFilter, setShowFilter] = useState(false);
  const [corporateCustomerDatas, setCorporateCustomerDatas] = useState<any>([]);
  const [retailCustomerDatas, setRetailCustomerDatas] = useState<any>([]);
  const [policyProductData, setPolicyProductData] = useState<any[]>([]);
  const [companyBranchData, setCompanyBranchData] = useState([]);
  const [insuranceCompanyList, setInsuranceCompanyList] = useState([]);

  const openFilter = () => {
    setShowFilter(true);
  };
  const hideFilter = () => {
    setShowFilter(false);

  };



  const toggleCompareScreen = (policy) => {
    if (!openComareScreen) {
      setSelectPolicyCompare(policy);

    } else {
      setSelectPolicyCompare(null);
      getEndorsementData();
    }
    setOpenCompareScreen(!openComareScreen);
  };
  const [showPreview, setShowPreview] = useState<{
    status: boolean;
    endorsementId: number | null;
    btn_text: string | null;
  }>({
    status: false,
    endorsementId: null,
    btn_text: null
  });


  const [anchorEl, setAnchorEl] = useState<any>(null);
  const [preview, setPreview] = useState({
    status: false,
    type: null,
    insuranceCompanyId: null,
    branchId: null,
    insuranceCompanyBranchId: null,
    insuranceCompanyBranchContact: null,
    otherContact: null,
    ids: null,
    endorsementType: null,
    premiumStatus: null,
    endorsementItem: null
  });
  const [insCompanyData, setInsCompanyData] = useState({
    insCompanyBranchId: null,
    insCompanyId: null,
    endorsementId: null
  });
  const open = Boolean(anchorEl);
  const endorsementScreenNumber = useSelector(selectEndorsmentScreenNumber);
  const handleChangePage = (event, newPage) => {
    setOffset(newPage);
  };

  const handleDeleteOpen = (item) => {
    setDeleteData(item);
    setDeleteOpen(true);
  };
  const closeDeleteOpen = () => {
    setDeleteData(null);
    setDeleteOpen(false);
    getEndorsementData();
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+parseInt(event.target.value));
    setOffset(0);
  };

  const changeSearch = (searchValue) => {
    setOffset(0);
    setSearch(searchValue);
  };

  useEffect(() => {
    checkRolePermission();
  }, [])

  useEffect(() => {
    getEndorsementData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowsPerPage, offset, search]);
  const getEndorsementData = async (filter = true, initialValues = null) => {
     setLoading(true);
    let values = initialValues ? initialValues : formik.values;
    request({
      url: 'endorsement/getEndorsements',
      method: 'post',
      data: {
        search: search?.text,
        orderColumn: 'id',
        orderDirection: 'DESC',
        offset: offset,
        limit: rowsPerPage,
        policyId: parseInt(policyId),
        customerType: values?.customerType == 'All' ? null : values?.customerType,

        corporateCustomerId: (() => {
          if (values?.customerType !== 'Corporate') {
            return null;
          }

          const customerIds = values?.customerIds || [];

          // If empty
          if (!customerIds.length) {
            return null;
          }

          // ALL selected
          if (customerIds.some((c) => c?.id === 'ALL')) {
            const ids = corporateCustomerDatas
              .map((c) => c.id)
              .filter((id) => id !== 'ALL');

            return ids.length ? ids : null;
          }

          // Specific selected IDs
          const ids = customerIds
            .map((c) => (typeof c === 'object' ? c.id : c))
            .filter(Boolean);

          return ids.length ? ids : null;
        })(),

        retailCustomerId: (() => {
          if (values?.customerType !== 'Retail') {
            return null;
          }

          const customerIds = values?.customerIds || [];

          // If empty
          if (!customerIds.length) {
            return null;
          }

          // ALL selected
          if (customerIds.some((c) => c?.id === 'ALL')) {
            const ids = retailCustomerDatas
              .map((c) => c.id)
              .filter((id) => id !== 'ALL');

            return ids.length ? ids : null;
          }

          // Specific selected IDs
          const ids = customerIds
            .map((c) => (typeof c === 'object' ? c.id : c))
            .filter(Boolean);

          return ids.length ? ids : null;
        })(),
        // Insurance Companies
        insuranceCompanyId: (() => {
          const companyList = values?.insuranceCompanyId || [];

          let ids = [];

          if (companyList.includes('ALL')) {
            ids = insuranceCompanyList
              .map((c) => c.id)
              .filter((id) => id !== 'ALL');
          } else {
            ids = companyList.filter(Boolean);
          }

          return ids.length ? ids : null;
        })(),

        insuranceCompanyBranchId: (() => {
          const branchList = values?.insurancBranchId || [];

          // if contains ALL -> return null
          const hasAll = branchList.some(
            (b) => b === 'ALL' || b?.id === 'ALL'
          );

          if (hasAll) {
            return null;
          }

          const ids = branchList
            .map((b) => (typeof b === 'object' ? b.id : b))
            .filter(Boolean);

          return ids.length ? ids : null;
        })(),
        policyProductId: (() => {
          const policyProductids = values?.policyProductId || [];

          // return null if empty
          if (!policyProductids.length) {
            return null;
          }

          // ALL selected
          if (policyProductids.some((b) => b?.id === 'ALL')) {
            return policyProductData
              .map((b) => b.id)
              .filter((id) => id !== 'ALL');
          }

          return policyProductids.map((b) =>
            typeof b === 'object' ? b.id : b
          );
        })(),
      }
    }).then(
      (response) => {
        setEndorsementListData(response['rows']);
        setTotalCount(response['count']);
        setLoading(false);
      },
      (error) => {
        console.log(error);
         setLoading(false);
      }
    );
  };

  const formik = useFormik({
    initialValues: {
      businessBranchId: [],
      type: 'all',
      startDate: null,
      endDate: null,
      insuranceCompanyId: ['ALL'],
      insurancBranchId: ['ALL'],
      status: ['All'],
      customerType: 'All',
      productCategory: [],
      relationShipManagerId: [{ branchName: 'All', id: 'ALL' }],
      customerIds: ['All'],
      policyProductId: [{ branchName: 'All', id: 'ALL' }]
    },
    onSubmit: (values) => {
      hideFilter();
      getEndorsementData(true, values);

    }
  });

  const resetFilter = () => {
    let initialValues = {
      businessBranchId: [],
      type: 'all',
      startDate: null,
      endDate: null,
      insuranceCompanyId: ['ALL'],
      insurancBranchId: ['ALL'],
      status: ['All'],
      customerType: 'All',
      productCategory: [],
      relationShipManagerId: [{ branchName: 'All', id: 'ALL' }],
      customerIds: ['All'],
      policyProductId: [{ branchName: 'All', id: 'ALL' }]
    }
    formik.resetForm({ values: initialValues });
    setTimeout(() => {
      getEndorsementData(true, initialValues);
    }, 100);
  };


  const checkRolePermission = async () => {
    await checkPermission('InsurancePolicyEndorsement', 'EndorsementQc').then((permission) => {
      setEndorsementQCPermission(permission);
    });
    await checkPermission('InsurancePolicyEndorsement', 'Create').then((permission) => {
      setEndorsementCreatePermission(permission);
    });
    await checkPermission('InsurancePolicyEndorsement', 'Delete').then((permission) => {
      setEndorsementDeletePermission(permission);
    });
    await checkPermission('InsurancePolicyEndorsement', 'View').then((permission) => {
      setEndorsementViewPermission(permission);
    });
    await checkPermission('InsurancePolicyEndorsement', 'Update').then((permission) => {
      setEndorsementUpdatePermission(permission);
    });
  };



  const handleSnackbarClose = () => {
    setShowSnackBarAlert({ status: false, type: null, message: null });
  };
  const showCreateEditForm = () => {
    setShowCreateEdit(true);
  };
  const closeCreateEditForm = (proceed = false) => {
    if (proceed === true) {
      setNonQCEditStatus(true);
    }
    setShowCreateEdit(false);
  };
  const editDatas = (editData) => {
    setEndoresementEditData(editData);
  };

  const closeShareToInsurerBox = () => {
    setOpenShareToInsurerBox(false);
    setEndoresementEditData(null);
    getEndorsementData();
  }

  const closeModal = () => {
    setEndoresementEditData(null);

    dispatch(
      updateEndorsementFormData({
        sumInsuredSectionData: {
          customerData: null,
          dynamicFormData: null,
          secondDynamicFormData: null,
          thirdDynamicFormData: null,
          sumInsuredSectionData: []
        }
      })
    )
    dispatch(updateEndorsementScreenNumber(1));
    if (qCEditStatus === true) {
      setQCEditStatus(false);
    } else {
      setNonQCEditStatus(false);
    }
    getEndorsementData();
  };

  const sharePreview = (
    type,
    insuranceCompanyBranchContact,
    customMail,
    premium,
    premiumType,
    paymentMode,
    bankAccountId,
    gstPercentage
  ) => {

    setLoader(true);
    if (type === 'PremiumRequsetToCustomer') {

      request({
        url: 'endorsement/shareToCustomer',
        method: 'POST',
        data: {
          type: type,
          insuranceCompanyId: insCompanyData.insCompanyId,
          insuranceCompanyBranchId: insCompanyData.insCompanyBranchId,
          // insuranceCompanyBranchContact: insuranceCompanyBranchContact,
          otherContact: customMail,
          ids: insCompanyData.endorsementId
            ? [insCompanyData.endorsementId]
            : [],
          premiumType,
          paymentType:
            paymentMode === 'BANK'
              ? (bankAccountId ? 'BANK' : null)
              : preview?.endorsementType === 'Non-Financial' ||
                ((preview?.endorsementType === 'Financial' ||
                  preview?.endorsementType === 'Both') &&
                  (premium === '0' || premium === null))
                ? (
                  preview?.premiumStatus === 'REFUND'
                    ? 'WALLET'
                    : (parseFloat(preview?.endorsementItem?.premium) > 0 ? 'WALLET' : null)
                )
                : paymentMode,
          bankAccountId: bankAccountId,
          premium,
          // premiumType,
          skipMailToInsurer: true,
          workFlowOption: 'Option 1',
          premiumSource: 'ManualEntry'
        }
      })
        .then((response) => {
          setLoader(false);
          setShowSnackBarAlert({
            status: true,
            type: 'success',
            message: 'Endorsement shared to customer'
          });
          closeModal();
          setPreview({
            status: false,
            type: null,
            insuranceCompanyId: null,
            branchId: null,
            insuranceCompanyBranchId: null,
            insuranceCompanyBranchContact: null,
            otherContact: null,
            ids: null,
            endorsementType: null,
            premiumStatus: null,
            endorsementItem: null
          });
          getEndorsementData();
          setEndorsementData(null);
          //   handleClose();
        })
        .catch(function (err) {
          setShowSnackBarAlert({
            status: true,
            type: 'error',
            message: err.message
          });
          setLoader(false);
          //   handleClose();
        });
    } else if (type === 'PremiumEnter') {

      request({
        url: 'endorsement/premiumRequestToInsurer',
        method: 'POST',
        data: {
          type: type,
          insuranceCompanyId: insCompanyData.insCompanyId,
          insuranceCompanyBranchId: insCompanyData.insCompanyBranchId,
          id: insCompanyData.endorsementId
            ? [insCompanyData.endorsementId]
            : [],
          premium,
          premiumType,
          skipMailToInsurer: true,
          workFlowOption: 'Option 2',
          premiumSource: 'ManualEntry',
          gst: gstPercentage
        }
      })
        .then((response) => {
          setLoader(false);
          setShowSnackBarAlert({
            status: true,
            type: 'success',
            message: 'Endorsement shared'
          });
          closeModal();
          getEndorsementData();
          setPreview({
            status: false,
            type: null,
            insuranceCompanyId: null,
            branchId: null,
            insuranceCompanyBranchId: null,
            insuranceCompanyBranchContact: null,
            otherContact: null,
            ids: null,
            endorsementType: null,
            premiumStatus: null,
            endorsementItem: null
          });
          //   handleClose();
        })
        .catch(function (err) {
          setShowSnackBarAlert({
            status: true,
            type: 'error',
            message: err.message
          });
          setLoader(false);
          //   handleClose();
        });
    } else {
      request({
        url: 'endorsement/premiumRequestToInsurer',
        method: 'POST',
        data: {
          type: type,
          insuranceCompanyId: insCompanyData.insCompanyId,
          insuranceCompanyBranchId: insCompanyData.insCompanyBranchId,
          insuranceCompanyBranchContact: insuranceCompanyBranchContact,
          otherContact: customMail,
          id: insCompanyData.endorsementId
            ? [insCompanyData.endorsementId]
            : [],
          premium: null,
          premiumType: null,
          skipMailToInsurer: false,
          workFlowOption: 'Option 2',
          premiumSource: 'Insurer'
        }
      })
        .then((response) => {
          setLoader(false);
          setShowSnackBarAlert({
            status: true,
            type: 'success',
            message: 'Endorsement premium requested'
          });
          getEndorsementData();
          setPreview({
            status: false,
            type: null,
            insuranceCompanyId: null,
            branchId: null,
            insuranceCompanyBranchId: null,
            insuranceCompanyBranchContact: null,
            otherContact: null,
            ids: null,
            endorsementType: null,
            premiumStatus: null,
            endorsementItem: null
          });
        })
        .catch(function (err) {
          setShowSnackBarAlert({
            status: true,
            type: 'error',
            message: err.message
          });
          setLoader(false);
        });
    }
  };

  const closeEndorsementQcBox = () => {
    setOpenEndorsementQcBox(false);
    setEndoresementEditData(null);
    getEndorsementData();
  }

  const closeEndorsementViewModal = () => {
    setOpenEndorsementView(false);
    setEndoresementEditData(null);

  };

  const closeEndorsementDocUpModal = () => {
    setEndoresementEditData(null);
    setOpenEndorsementDocUploadForm(false);
    getEndorsementData();
  };

  const handleRequest = (
    type,
    endorsementId?: any,
    insCompanyId?: any,
    insCompanyBranchId?: any,
    endorsementType?: any,
    premiumStatus?: any,
    endorsementItem?: any
  ) => {
    setInsCompanyData({
      insCompanyBranchId,
      insCompanyId,
      endorsementId
    });
    setAnchorEl(null);
    setPreview({
      status: true,
      type,
      insuranceCompanyId: insCompanyId,
      branchId: null,
      insuranceCompanyBranchId: insCompanyBranchId,
      insuranceCompanyBranchContact: null,
      otherContact: null,
      ids: endorsementId ? [endorsementId] : [],
      endorsementType,
      premiumStatus,
      endorsementItem
    });
  };
  return (
    <>
      {preview.status && (
        <PremiumRequestPreview
          sharePreview={sharePreview}
          preview={preview}
          setPreview={setPreview}
          loader={loaders}
          endorsementData={preview.endorsementItem}
          setShowSnackBarAlert={setShowSnackBarAlert}
          getEndorsementData={getEndorsementData}
        />
      )}

      {showFilter && (
        <AdvancedFilter
          hideFilter={hideFilter}
          submitFilter={getEndorsementData}
          setCorporateCustomerDatas={setCorporateCustomerDatas}
          corporateCustomerDatas={corporateCustomerDatas}
          setRetailCustomerDatas={setRetailCustomerDatas}
          retailCustomerDatas={retailCustomerDatas}
          setCompanyBranchData={setCompanyBranchData}
          companyBranchData={companyBranchData}
          insuranceCompanyList={insuranceCompanyList}
          setInsuranceCompanyList={setInsuranceCompanyList}
          setPolicyProductData={setPolicyProductData}
          policyProductData={policyProductData}
          formik={formik}
        />
      )}

      {qCEditStatus && (
        <UploadPolicyDoc
          closeModal={closeModal}
          editData={endoresementEditDatas}
          setShowSnackBarAlert={setShowSnackBarAlert}
        />
      )}

      {openShareToInsurerBox && <ShareToInsurer setShowSnackBarAlert={setShowSnackBarAlert} endoresementData={endoresementEditDatas} onClose={closeShareToInsurerBox} />}

      {deleteopen && <CancelEndorsementDialog endorsementId={deleteData?.id} closeModal={closeDeleteOpen} />}

      {showPreview?.status && <ReshareEndorsementPreview showPreview={showPreview} setShowPreview={setShowPreview} />}

      {openEndorsementDocUploadForm && (
        <UploadEndorsementDoc
          closeModal={closeEndorsementDocUpModal}
          editData={endoresementEditDatas}
          setShowSnackBarAlert={setShowSnackBarAlert}
        />
      )}

      {openEndorsementView && (
        <EndorsementView
          onClose={closeEndorsementViewModal}
          endoresementEditDatas={endoresementEditDatas}
        />
      )}
      {openEndorsementQcBox && <QcComparisonDialog onClose={closeEndorsementQcBox}
        endorsementData={endoresementEditDatas}
        setShowSnackBarAlert={setShowSnackBarAlert}
      />}



      {nonQCEditStatus && endorsementScreenNumber === 1 && (
        <EndorsementUpdateScreenOne
          closeModal={closeModal}
          editData={endoresementEditDatas}
          setShowSnackBarAlert={setShowSnackBarAlert}
        />
      )}

      {nonQCEditStatus && endorsementScreenNumber === 2 && (
        <EndorsementUpdateScreenTwo
          closeModal={closeModal}
          setShowSnackBarAlert={setShowSnackBarAlert}
        />
      )}

      {nonQCEditStatus && endorsementScreenNumber === 3 && (
        <EndorsementPreview
          closeModal={closeModal}
          setShowSnackBarAlert={setShowSnackBarAlert}
          setAnchorEl={setAnchorEl}
          anchorEl={anchorEl}
          preview={preview}
          setPreview={setPreview}
          open={open}
          setEndorsementData={setEndorsementData}
          endorsementData={endorsementData}
          getEndorsementData={getEndorsementData}
        />
      )}

      {showCreateEdit && (
        <CreateEdit
          onClose={closeCreateEditForm}
          setShowSnackBarAlert={setShowSnackBarAlert}
          fetchData={getEndorsementData}
        />
      )}

      <SnackbarAlert
        showSnackBarAlert={showSnackBarAlert}
        handleSnackbarClose={handleSnackbarClose}
      />

      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid
            item
            xs={12}
            className="ListContainer"
            style={{ minHeight: '81vh' }}
          >
            {endorsementViewPermission ? (<Card>
              <Grid container mt={1} mb={1} mr={1} ml={1.5}>
                <Grid item xs={4}>
                  <Typography variant="h3" component="h3" gutterBottom>
                    Endorsements
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  {endorsementCreatePermission && <Button
                    sx={{ mt: { xs: 2, md: 0 }, mr: { md: 2 } }}
                    variant="contained"
                    startIcon={<AddTwoToneIcon fontSize="small" />}
                    onClick={showCreateEditForm}
                  >
                    Create
                  </Button>}

                </Grid>
                <Grid item xs={4}>
                  <TableSearchWithIcon
                    changeSearch={changeSearch}
                    deafultSearchValue={search.text}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Stack direction={'row'}>
                    <IconButton
                      aria-label="Example"
                      // sx={{ marginLeft: 'auto' }}
                      onClick={openFilter}
                    >
                      <Tooltip title="Apply Filter" arrow>
                        <FilterAltIcon
                          // sx={{ marginLeft: 'auto' }}
                          fontSize="medium"
                          color="primary"
                        />
                      </Tooltip>
                    </IconButton>

                    {
                      (formik.values?.policyProductId?.length > 0 &&
                        !formik.values?.policyProductId?.some(
                          (item) => item?.id === 'ALL'
                        )) ||
                        (formik.values?.customerType &&
                          formik.values?.customerType !== 'All') ||
                        (formik.values?.insuranceCompanyId?.length > 0 &&
                          !formik.values?.insuranceCompanyId?.includes('ALL')) ||
                        (formik.values?.insurancBranchId?.length > 0 &&
                          !formik.values?.insurancBranchId?.includes('ALL')) ||
                        (formik.values?.customerIds?.length > 0 &&
                          !formik.values?.customerIds?.includes('All')) ? (
                        <IconButton
                          aria-label="Example"
                          sx={{ float: 'right' }}
                          onClick={() => resetFilter()}
                        >
                          <Tooltip title="Reset Filter" arrow>
                            <RestartAltIcon
                              sx={{ float: 'right' }}
                              fontSize="medium"
                              color="primary"
                            />
                            {/* </Badge> */}
                          </Tooltip>
                        </IconButton>
                      ) : null}
                  </Stack>
                </Grid>
              </Grid>

              <Divider />


              {isLoading ? (
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell align="center">
                          <img
                            alt="loader"
                            src={loader}
                            className="loader"
                            width={100}
                            height={100}
                          />
                        </TableCell>
                      </TableRow>
                    </TableHead>
                  </Table>
                </TableContainer>
              ) : (
                <TableContainer>
                  {endorsementListData?.length > 0 ? (
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>#</TableCell>
                          <TableCell>Policy number</TableCell>
                          <TableCell>Endorsement number</TableCell>
                          <TableCell align="center">Type</TableCell>
                           <TableCell align="center">Product</TableCell>
                          <TableCell align="center">Customer</TableCell>
                          <TableCell align="center">Created By</TableCell>
                          <TableCell align="center" style={{ minWidth: '107px' }}>Issue Date</TableCell>
                          <TableCell align="center">Status</TableCell>
                          <TableCell align="left">Actions</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {endorsementListData?.map((item, index) => (
                          <TableRow hover key={item?.id}>
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>
                              {item?.insurancePolicy?.policyNumber}
                            </TableCell>
                            <TableCell>
                              {item?.endorsementNumber ? item?.endorsementNumber : 'N/A'}
                            </TableCell>
                            <TableCell align="center">{item.type}</TableCell>
                            <TableCell align="center">{item.insurancePolicy?.rfq?.policyProduct?.name}</TableCell>
                             <TableCell align="center">{item.insurancePolicy?.customerType=='Corporate'?item?.insurancePolicy?.corporateCustomer?.companyName:item?.insurancePolicy?.retailCustomer?.name}</TableCell>
                            <TableCell align="center">
                              {item.createdBy
                                ? `${item.createdBy?.firstName} ${item.createdBy?.lastName}`
                                : ''}
                            </TableCell>
                            <TableCell align="center">
                              {item?.endorsementDocumentIssueDate ? moment(item?.endorsementDocumentIssueDate).format('DD-MM-YYYY') : 'N/A'}
                            </TableCell>

                            <TableCell align="center">
                              <Tooltip
                                title={item?.qcDescription?.trim() || ''}
                                arrow
                                disableHoverListener={!item?.qcDescription?.trim()}
                              >
                                <span>
                                  <Chip
                                    label={
                                      item?.status === 'Inprogress'
                                        ? 'In Progress'
                                        : item?.status
                                    }
                                    color={
                                      item?.status === 'Live'
                                        ? 'success'
                                        : ['Cancelled', 'Expired'].includes(item?.status)
                                          ? 'error'
                                          : 'primary'
                                    }
                                    size="small"
                                  />
                                </span>
                              </Tooltip>


                            </TableCell>
                            <TableCell>
                              <Tooltip
                                title={
                                  endorsementViewPermission ? (
                                    'View Endorsement'
                                  ) : (
                                    <div
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center'
                                      }}
                                    >
                                      {' '}
                                      <Avatar
                                        alt=""
                                        src={lock}
                                        sx={{
                                          width: 24,
                                          height: 24,
                                          marginRight: 1
                                        }}
                                      />
                                      You don't have permission to view
                                      policy
                                    </div>
                                  )
                                }
                                arrow>
                                <span>
                                  <IconButton
                                    disabled={!endorsementViewPermission}
                                    sx={{
                                      '&:hover': {
                                        background: theme.colors.primary.lighter
                                      },
                                      color: theme.palette.primary.main
                                    }}
                                    size="small"
                                    onClick={() => {
                                      setOpenEndorsementView(true);
                                      editDatas(item);
                                    }}
                                  >
                                    <VisibilityIcon fontSize="small" />
                                  </IconButton>
                                </span>
                              </Tooltip>
                              {(item.status == 'Shared To Insurer' || item.status == 'Revised') && item.type != 'QC' && item.status != 'Completed' && <Tooltip

                                title={
                                  endorsementUpdatePermission ? (
                                    'Upload endorsement document'
                                  ) : (
                                    <div
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center'
                                      }}
                                    >
                                      {' '}
                                      <Avatar
                                        alt=""
                                        src={lock}
                                        sx={{
                                          width: 24,
                                          height: 24,
                                          marginRight: 1
                                        }}
                                      />
                                      You don't have permission to Upload endorsement document
                                      policy
                                    </div>
                                  )
                                }
                                arrow>
                                <span>
                                  <IconButton
                                    disabled={!endorsementUpdatePermission}
                                    sx={{
                                      '&:hover': {
                                        background: theme.colors.primary.lighter
                                      },
                                      color: theme.palette.primary.main
                                    }}
                                    size="small"
                                    onClick={() => {
                                      setOpenEndorsementDocUploadForm(true);
                                      editDatas(item);
                                    }}
                                  >
                                    <FileUploadIcon fontSize="small" />
                                  </IconButton>
                                </span>
                              </Tooltip>}


                              {(item.status === 'Shared To Insurer'
                                // || item.status === 'Shared To Customer'
                              ) && (
                                  <Tooltip
                                    title={
                                      endorsementUpdatePermission ? (
                                        item.status === 'Shared To Insurer' ? 'Reshare to Insurer' : ' Reshare to Customer'
                                      ) : (
                                        <div
                                          style={{
                                            display: 'flex',
                                            alignItems: 'center'
                                          }}
                                        >
                                          <Avatar
                                            alt=""
                                            src={lock}
                                            sx={{
                                              width: 24,
                                              height: 24,
                                              marginRight: 1
                                            }}
                                          />
                                          You don’t have permission to reshare to insurer
                                        </div>
                                      )
                                    }
                                    arrow
                                  >
                                    <span>
                                      <IconButton
                                        disabled={!endorsementUpdatePermission}
                                        sx={{
                                          '&:hover': {
                                            background: theme.colors.primary.lighter
                                          },
                                          color: theme.palette.primary.main
                                        }}
                                        size="small"
                                        onClick={() => {
                                          setShowPreview({
                                            status: true,
                                            endorsementId: item.id,
                                            btn_text: item.status === 'Shared To Insurer' ? 'Reshare to Insurer' : ' Reshare to Customer'
                                          });
                                        }}
                                      >
                                        <ForwardIcon fontSize="small" />
                                      </IconButton>
                                    </span>
                                  </Tooltip>
                                )}


                              {item.type === 'QC' && item.status != 'Waiting For QC' && item?.status != 'Cancelled' && item.status != 'Completed' && item?.status != 'Resend' && item?.status != 'Closed' && <Tooltip

                                title={
                                  endorsementUpdatePermission ? (
                                    'Upload endorsement document'
                                  ) : (
                                    <div
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center'
                                      }}
                                    >
                                      {' '}
                                      <Avatar
                                        alt=""
                                        src={lock}
                                        sx={{
                                          width: 24,
                                          height: 24,
                                          marginRight: 1
                                        }}
                                      />
                                      You don't have permission to Upload endorsement document
                                      policy
                                    </div>
                                  )
                                }
                                arrow>
                                <span>
                                  <IconButton
                                    disabled={!endorsementUpdatePermission}
                                    sx={{
                                      '&:hover': {
                                        background: theme.colors.primary.lighter
                                      },
                                      color: theme.palette.primary.main
                                    }}
                                    size="small"
                                    onClick={() => {
                                      if (item.type === 'QC') {
                                        // setQCEditStatus(true);
                                        setOpenEndorsementDocUploadForm(true); // now both case use same form
                                      } else {
                                        setOpenEndorsementDocUploadForm(true);
                                      }
                                      editDatas(item);
                                    }}
                                  >
                                    <FileUploadIcon fontSize="small" />
                                  </IconButton>
                                </span>
                              </Tooltip>}

                              {(item?.status == 'Customer Approved') ? (<Tooltip

                                title={
                                  endorsementUpdatePermission ? (
                                    'Share To Insurer'
                                  ) : (
                                    <div
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center'
                                      }}
                                    >
                                      {' '}
                                      <Avatar
                                        alt=""
                                        src={lock}
                                        sx={{
                                          width: 24,
                                          height: 24,
                                          marginRight: 1
                                        }}
                                      />
                                      You don't have permission to share to insurer
                                      policy
                                    </div>
                                  )
                                }
                                arrow>
                                <span>
                                  <IconButton
                                    disabled={!endorsementUpdatePermission}
                                    sx={{
                                      '&:hover': {
                                        background: theme.colors.primary.lighter
                                      },
                                      color: theme.palette.primary.main
                                    }}
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                      setOpenShareToInsurerBox(true);
                                      editDatas(item)

                                    }}
                                  >
                                    <ShareIcon fontSize="small" />
                                  </IconButton>
                                </span>
                              </Tooltip>) : null}

                              {(item?.status === 'Premium Received' &&
                                (item?.type === 'Financial' ||
                                  item?.type === 'Both')) ||
                                (item?.type ===
                                  'Non-Financial' &&
                                  item?.status !== 'Shared To Customer' &&
                                  item?.status !== 'Cancelled' &&
                                  item?.status !== 'Shared To Insurer' &&
                                  item?.status !== 'Waiting For QC' &&
                                  item?.status !== 'Completed' &&
                                  item?.status !== 'Customer Approved') ? (
                                <Tooltip
                                  title={
                                    endorsementUpdatePermission ? (
                                      'Share To Customer'
                                    ) : (
                                      <div
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center'
                                        }}
                                      >
                                        {' '}
                                        <Avatar
                                          alt=""
                                          src={lock}
                                          sx={{
                                            width: 24,
                                            height: 24,
                                            marginRight: 1
                                          }}
                                        />
                                        You don't have permission to share To customer
                                        policy
                                      </div>
                                    )
                                  }
                                  arrow>
                                  <span>
                                    <IconButton
                                      disabled={!endorsementUpdatePermission}
                                      sx={{
                                        '&:hover': {
                                          background: theme.colors.primary.lighter
                                        },
                                        color: theme.palette.primary.main
                                      }}
                                      color="inherit"
                                      size="small"
                                      onClick={() =>
                                        handleRequest(
                                          'PremiumRequsetToCustomer',
                                          item.id,
                                          item.insurancePolicy.insuranceCompany
                                            .id,
                                          item.insurancePolicy
                                            .insuranceCompanyBranch.id,
                                          item?.endorsementData?.type,
                                          item?.premiumStatus,
                                          item
                                        )
                                      }
                                    >
                                      <ShareIcon fontSize="small" />
                                    </IconButton>
                                  </span>
                                </Tooltip>
                              ) : null}
                              {item?.status === 'Inprogress' &&
                                (item?.endorsementData?.type === 'Financial' ||
                                  item?.endorsementData?.type === 'Both' || item?.endorsementData?.type === 'Extension-Endorsement' || item?.endorsementData?.type === 'Cancellation-Endorsement') ? (
                                <Tooltip
                                  title={
                                    endorsementUpdatePermission ? (
                                      'Request Premium'
                                    ) : (
                                      <div
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center'
                                        }}
                                      >
                                        {' '}
                                        <Avatar
                                          alt=""
                                          src={lock}
                                          sx={{
                                            width: 24,
                                            height: 24,
                                            marginRight: 1
                                          }}
                                        />
                                        You don't have permission to request premium
                                        policy
                                      </div>
                                    )
                                  }
                                  arrow>
                                  <span>
                                    <IconButton
                                      disabled={!endorsementUpdatePermission}
                                      sx={{
                                        '&:hover': {
                                          background: theme.colors.primary.lighter
                                        },
                                        color: theme.palette.primary.main
                                      }}
                                      color="inherit"
                                      size="small"
                                      onClick={() =>
                                        handleRequest(
                                          'PremiumRequset',
                                          item.id,
                                          item.insurancePolicy.insuranceCompany
                                            .id,
                                          item.insurancePolicy
                                            .insuranceCompanyBranch.id,
                                          item?.endorsementData?.type,
                                          item?.premiumStatus,
                                          item
                                        )
                                      }
                                    >
                                      <SendIcon fontSize="small" />
                                    </IconButton>
                                  </span>
                                </Tooltip>
                              ) : null}
                              {(item?.status === 'Awaiting Insurer Premium' ||
                                item?.status === 'Inprogress') &&
                                (item?.endorsementData?.type === 'Financial' ||
                                  item?.endorsementData?.type === 'Both' || item?.endorsementData?.type === 'Extension-Endorsement' || item?.endorsementData?.type === 'Cancellation-Endorsement') ? (
                                <Tooltip

                                  title={
                                    endorsementUpdatePermission ? (
                                      'Enter Premium'
                                    ) : (
                                      <div
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center'
                                        }}
                                      >
                                        {' '}
                                        <Avatar
                                          alt=""
                                          src={lock}
                                          sx={{
                                            width: 24,
                                            height: 24,
                                            marginRight: 1
                                          }}
                                        />
                                        You don't have permission to enter premium
                                        policy
                                      </div>
                                    )
                                  }
                                  arrow>
                                  <span>
                                    <IconButton
                                      disabled={!endorsementUpdatePermission}
                                      sx={{
                                        '&:hover': {
                                          background: theme.colors.primary.lighter
                                        },
                                        color: theme.palette.primary.main
                                      }}
                                      color="inherit"
                                      size="small"
                                      onClick={() =>
                                        handleRequest(
                                          'PremiumEnter',
                                          item.id,
                                          item.insurancePolicy.insuranceCompany
                                            .id,
                                          item.insurancePolicy
                                            .insuranceCompanyBranch.id,
                                          item?.endorsementData?.type,
                                          item?.premiumStatus,
                                          item
                                        )
                                      }
                                    >
                                      <MonetizationOnIcon fontSize="small" />
                                    </IconButton>
                                  </span>
                                </Tooltip>
                              ) : null}
                              {item?.status === 'Shared To Customer' ? (
                                <Tooltip
                                  title={
                                    endorsementUpdatePermission ? (
                                      'Approve Endorsement'
                                    ) : (
                                      <div
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center'
                                        }}
                                      >
                                        {' '}
                                        <Avatar
                                          alt=""
                                          src={lock}
                                          sx={{
                                            width: 24,
                                            height: 24,
                                            marginRight: 1
                                          }}
                                        />
                                        You don't have permission to approve endorsement
                                        policy
                                      </div>
                                    )
                                  } arrow>
                                  <span>
                                    <IconButton
                                      disabled={!endorsementUpdatePermission}
                                      sx={{
                                        '&:hover': {
                                          background: theme.colors.primary.lighter
                                        },
                                        color: theme.palette.primary.main
                                      }}
                                      color="inherit"
                                      size="small"
                                      onClick={() =>
                                        handleRequest(
                                          'Approve Endorsement',
                                          item.id,
                                          item.insurancePolicy.insuranceCompany
                                            .id,
                                          item.insurancePolicy
                                            .insuranceCompanyBranch.id,
                                          item?.endorsementData?.type,
                                          item?.premiumStatus,
                                          item
                                        )
                                      }
                                    >
                                      <CheckCircleIcon />
                                    </IconButton>
                                  </span>
                                </Tooltip>
                              ) : null}
                              {item?.status === 'Waiting For QC' && item.type != 'QC' ? (
                                <Tooltip
                                  title={
                                    endorsementQCPermission ? (
                                      'Endorsement QC'
                                    ) : (
                                      <div
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center'
                                        }}
                                      >
                                        {' '}
                                        <Avatar
                                          alt=""
                                          src={lock}
                                          sx={{
                                            width: 24,
                                            height: 24,
                                            marginRight: 1
                                          }}
                                        />
                                        You don't have permission to endorsement QC
                                        policy
                                      </div>
                                    )
                                  }
                                  arrow>
                                  <span>
                                    <IconButton
                                      disabled={!endorsementQCPermission}
                                      sx={{
                                        '&:hover': {
                                          background: theme.colors.primary.lighter
                                        },
                                        color: theme.palette.primary.main
                                      }}
                                      color="inherit"
                                      size="small"
                                      onClick={() => {
                                        setOpenEndorsementQcBox(true);
                                        editDatas(item);

                                      }
                                      }
                                    >
                                      <CompareArrowsIcon />
                                    </IconButton>
                                  </span>
                                </Tooltip>
                              ) : null}

                              {item?.status != 'Waiting For QC' && item?.status != 'Completed' && item?.status != 'Cancelled' && item?.status != 'Resend' && item?.status != 'Closed' ? (
                                <Tooltip
                                  title={
                                    endorsementDeletePermission ? (
                                      'Cancel Endorsements'
                                    ) : (
                                      <div
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center'
                                        }}
                                      >
                                        {' '}
                                        <Avatar
                                          alt=""
                                          src={lock}
                                          sx={{
                                            width: 24,
                                            height: 24,
                                            marginRight: 1
                                          }}
                                        />
                                        You don't have permission to cancel endorsement
                                        policy
                                      </div>
                                    )
                                  }
                                  arrow>
                                  <IconButton
                                    disabled={!endorsementDeletePermission}
                                    sx={{
                                      '&:hover': {
                                        background: theme.colors.error.lighter
                                      },
                                      color: theme.palette.error.main
                                    }}
                                    color="inherit"
                                    size="small"
                                    onClick={() => handleDeleteOpen(item)}
                                  >
                                    <HighlightOffIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              ) : null}
                              <Tooltip
                                title={
                                  endorsementViewPermission ? (
                                    'History'
                                  ) : (
                                    <div
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center'
                                      }}
                                    >
                                      {' '}
                                      <Avatar
                                        alt=""
                                        src={lock}
                                        sx={{
                                          width: 24,
                                          height: 24,
                                          marginRight: 1
                                        }}
                                      />
                                      You don't have permission to view history
                                      policy
                                    </div>
                                  )
                                }
                                arrow>
                                <IconButton
                                  sx={{
                                    '&:hover': {
                                      background: theme.colors.primary.lighter
                                    },
                                    color: theme.palette.primary.main
                                  }}
                                  color="inherit"
                                  size="small"
                                  component={Link}
                                  to={
                                    `/dashboards/endorsement-history?endorsement\_id=` +
                                    item.id
                                  }
                                >
                                  <HistoryIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>

                              {item?.status != 'Cancelled' && item?.status != 'Resend' && item?.status != 'Closed' && <Tooltip title="Attachments">
                                <IconButton
                                  size="small"
                                  onClick={() => {
                                    setSelectedEndorsement(item);
                                    setOpenAttachmentDialog(true);
                                  }}
                                >
                                  <AttachFileIcon color="primary" fontSize="small" />
                                </IconButton>
                              </Tooltip>}

                              {item.status === 'Waiting For QC' && item.type === 'QC' && (
                                <Tooltip
                                  title={
                                    policyQCPermission ? (
                                      'QC'
                                    ) : (
                                      <div
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center'
                                        }}
                                      >
                                        {' '}
                                        <Avatar
                                          alt=""
                                          src={lock}
                                          sx={{
                                            width: 24,
                                            height: 24,
                                            marginRight: 1
                                          }}
                                        />
                                        You don't have permission to compare
                                        policy
                                      </div>
                                    )
                                  }
                                  arrow
                                >
                                  <IconButton
                                    sx={{
                                      '&:hover': {
                                        background: theme.colors.primary.lighter
                                      },
                                      color: theme.palette.primary.main
                                    }}
                                    size="small"
                                    onClick={() => {
                                      toggleCompareScreen(item);
                                    }}
                                  >
                                    <CompareArrowsIcon fontSize="small"
                                      color={
                                        !policyQCPermission ||
                                          item?.policyCancellationStatus === true
                                          ? 'disabled'
                                          : 'primary'
                                      }
                                    />
                                  </IconButton>
                                </Tooltip>
                              )}




                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  ) : (
                    <NoDataAvailable />
                  )}
                </TableContainer>
              )}

              <Box p={2}>
                <TablePagination
                  rowsPerPageOptions={[25, 50, 75, 100]}
                  component="div"
                  count={totalCount}
                  rowsPerPage={rowsPerPage}
                  page={offset}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Box>


            </Card>) : (<NoPermissionContent />)}
          </Grid>
        </Grid>
      </Container>

      {openAttachmentDialog && <EndorsementAttachmentDialog
        onClose={() => setOpenAttachmentDialog(false)}
        endorsementId={selectedEndorsement?.id}
        policyId={selectedEndorsement?.policyId}
      />}


      {openComareScreen && (
        //PolicyCompare replaced by PolicyDataCompare
        <PolicyDataCompare
          handleClose={toggleCompareScreen}
          PolicyCompare={selectPolicyCompare}
        />
      )}


      <Footer />
    </>
  );
}

export default EndorsementList;